const API_URL = process.env.REACT_APP_authServiceURL;
const ML_URL = `${API_URL}/recommend`;


const Apis = {

    //Location API
    GetCountryData: `${API_URL}/backend/region/countries`,
    GetStatesData: (countryName) => `${API_URL}/backend/region/states/${countryName}`,
    GetCitiesData: (stateName) => `${API_URL}/backend/region/cities/${stateName}`,

    //Institute Category API
    GetCategoryList: `${API_URL}/institute-class/config-categories`,
    GetClassConfigList: (instituteId) => `${API_URL}/institute-class/config-class?instituteId=${instituteId}`,
    GetCategoryConfigList: (data) => `${API_URL}/institute-class/config-news?instituteId=${data?.instituteId}&studentClass=${data?.studentClass}`,
    GetAllClassCategoriesList: (instituteId) => `${API_URL}/institute-class/get-all-class-categories?instituteId=${instituteId}`,
    SaveClassCategory: `${API_URL}/institute-class/save-category`,
    UpdateClassCategory: `${API_URL}/institute-class/update-category`,
    DeleteClassCategory: (data) => `${API_URL}/institute-class/delete?instituteId=${data?.instituteId}&studentClass=${data?.studentClass}`,

    //Individual API 
    IndividualUserRegister: `${API_URL}/individual/signup`,
    IndividualLogin: `${API_URL}/individual/login`,
    IndividualProfileUpdate: `${API_URL}/individual/update`,
    IndividualOtpVerify: `${API_URL}/otp/individual/signup`,
    IndividualOtpResend: (transactionId) => `${API_URL}/otp/individual_signup_otp_resend?transactionId=${transactionId}`,
    IndividualChangePasswordOtpResend: (transactionId) => `${API_URL}/otp/individual_password_change_otp_re_send?transactionId=${transactionId}`,

    PasswordChangeOtp: (data) => `${API_URL}/otp/${data?.type === "institution" ? data?.userType === "FACULTY" ? "faculty_password_change_otp_send" : "password_change_otp_send_institute" : data?.type === "individual" ? "individual_password_change_otp_send" : "student_password_change_otp_send"}?email=${data?.email}`,
    UserChangePasswordOtpResend: (transactionId) => `${API_URL}/otp/student_password_change_otp_re_send?transactionId=${transactionId}`,

    //Intitute Admin API
    CreateInstituteAdmin: `${API_URL}/institute/admin/add`,
    RemoveInstituteAdmin: `${API_URL}/institute/admin/remove`,
    GetInstituteAdminList: (instituteId) => `${API_URL}/institute/admin/list?instituteId=${instituteId}`,

    //Analytics API
    GetInstituteAnalyticsCategorywise: (data) => `${ML_URL}/users/inst-news-class-categorywise-read?instituteId=${data?.instituteId}&classString=${data?.classString}&dateString=${data?.dateString}&page=${data?.page}&size=${data?.size}`,
    GetInstituteAnalyticsConsumptionDuringDays: (data) => `${ML_URL}/users/timewise-consumption?instituteId=${data?.instituteId}&dateString=${data?.dateString}&page=${data?.page}&size=${data?.size}`,
    GetInstituteCompareAnalyticsData: (data) => `${ML_URL}/users/compare-class-entity?instituteId=${data?.instituteId}&dateString=${data?.dateString}&classString=${data?.classString}&entity=${data?.entity}&page=${data?.page}&size=${data?.size}`,
    GetCandidateAnalyticsCategorywise: (data) => `${ML_URL}/users/student-news-categorywise-read?studentId=${data?.studentId}&dateString=${data?.dateString}&page=${data?.page}&size=${data?.size}`,
    GetCandidateCompareAnalyticsData: (data) => `${ML_URL}/users/student-entity-comparison?studentId=${data?.studentId}&dateString=${data?.dateString}&entity=${data?.entity}&page=${data?.page}&size=${data?.size}`,
    GetInstituteAnalyticsQuizCategorywise: (data) => `${ML_URL}/users/inst-quiz-class-categorywise-attempts?instituteId=${data?.instituteId}&classString=${data?.classString}&dateString=${data?.dateString}&page=${data?.page}&size=${data?.size}`,
    GetCandidateAnalyticsQuizCategorywise: (data) => `${ML_URL}/users/student-quiz-categorywise-attempts?studentId=${data?.studentId}&dateString=${data?.dateString}&page=${data?.page}&size=${data?.size}`,

    //Transaction API
    GetTransactionDataByUserType: (data) => `${API_URL}/transaction/list?userId=${data?.userId}&creditType=${data?.creditType}&userType=${data?.userType}&page=${data?.page}&size=${data?.size}`,

    //Institute Quiz Summary Apis

    GetQuizSummaryData: (data) => `${API_URL}/quiz/summary/list?instituteId=${data?.instituteId}&filter=${data?.filter}&year=${data?.year}&page=${data?.page}&size=${data?.size}`,
    GetQuizSummaryClassWise: (data) => `${API_URL}/quiz/summary/classwise/list?instituteId=${data?.instituteId}&studentClass=${data?.studentClass}&filter=${data?.filter}&year=${data?.year}&searchType=${data?.searchType}&searchQuery=${data?.searchQuery}&page=${data?.page}&size=${data?.size}`,
    GetQuizSummaryByUserId: (data) => `${API_URL}/quiz/summary/classwise/student/list?instituteId=${data?.instituteId}&userId=${data?.userId}&studentClass=${data?.studentClass}&filter=${data?.filter}&page=${data?.page}&size=${data?.size}`,
    GetQuizSummaryCandidateData: (data) => `${API_URL}/quiz/summary/student/list?userId=${data?.userId}&filter=${data?.filter}&page=${data?.page}&size=${data?.size}`,

    //Faculty Api

    GetSubjectsListDataByBoardId: (boardId) => `${API_URL}/board/getById?boardId=${boardId}`,
    CreateFaculty: `${API_URL}/faculty/create`,
    UpdateFaculty: `${API_URL}/faculty/update-data`,
    GetFacultyList: (data) => `${API_URL}/faculty/list?searchType=${data?.searchType}&searchQuery=${data?.searchQuery}&instituteId=${data?.instituteId}`,
    FacultyLogin: `${API_URL}/faculty/login`,
    ChangePasswordOtpResendFaculty: (transactionId) => `${API_URL}/otp/faculty_password_change_otp_re_send?transactionId=${transactionId}`,

    //Curriculam API
    CreateCurriculam: `${API_URL}/curriculum/create`,
    GetCurriculam: (instituteId) => `${API_URL}/curriculum/get?instituteId=${instituteId}`,
    GetCurriculamSubjectList: (data) => `${API_URL}/curriculum/get/subjects?instituteId=${data?.instituteId}&studentClass=${data?.studentClass}`,
    CreateCurriculamChapter: `${API_URL}/chapter/add`,
    UpdateCurriculamChapter: `${API_URL}/chapter/update`,
    DeleteCurriculamChapter: `${API_URL}/chapter/delete`,
    GetCurriculamChapter: (data) => `${API_URL}/chapter/get?subjectId=${data?.subjectId}&curriculumId=${data?.curriculumId}`,

    //Assignment API
    CreateAssignment: `${API_URL}/assignment/create`,
    GetAssignmentList: (data) => `${API_URL}/assignment/list?instituteId=${data?.instituteId}&studentClass=${data?.studentClass}&subjectId=${data?.subjectId}`,
    GetAssignmentDetailsById: (assignmentId) => `${API_URL}/assignment/question_list?assignmentId=${assignmentId}`,

    //How to use API
    GetHowToUseListData: (data) => `${API_URL}/how-to-use/enable-list?&page=${data.page}&size=${data.size}`,

    //User Stories API
    GetUserStoriesListData: (data) => `${API_URL}/story/enable-list?&page=${data.page}&size=${data.size}`,

    //FAQ API
    GetFaqListData: (data) => `${API_URL}/faq/public/list?&searchQuery=${data?.searchQuery}&searchType=${data?.searchType}`,
    GetFaqDataBySlug: (data) => `${API_URL}/faq/get-by-slug?&slug=${data?.slug}`,
    GetCategoryData: (data) => `${API_URL}/faq/category-wise/list?&searchQuery=${data?.searchQuery}&categorySlug=${data?.categorySlug}&searchType=${data?.searchType}`,
    GetTopCategoriesData: (data) => `${API_URL}/faq_category/category-with-active-question`,
    GetFaqMetaBySlug: (slug) => `${API_URL}/faq/getMetaDataByslug?slug=${slug}`,

    // BlogsAPI
    GetBlogListData: (data) => `${API_URL}/backend/blog/public/list?&page=${data?.page}&size=${data?.size}`,
    GetTopBlogCategoryData: `${API_URL}/backend/blog-category/public/list-count`,
    GetBlogDataBySlug: (slug) => `${API_URL}/backend/blog/get-by-slug?&slug=${slug}`,
    GetBlogCategoryData: (data) => `${API_URL}/backend/blog/category-wise/list?&slug=${data?.slug}&page=${data?.page}&size=${data?.size}`,
    GetPopularBlogsData: (data) => `${API_URL}/backend/blog/recent-list?&page=${data.page}&size=${data.size}`,
    GetBlogMetaBySlug: (slug) => `${API_URL}/backend/blog/getMetaDataByslug?slug=${slug}`,

    // Media coverage API
    GetMediaCoverageData: (data) => `${API_URL}/media/get-by-publication?&page=${data?.page}&size=${data?.size}&publicationName=${data?.publication}`,
    GetMediaPublicationsListData: `${API_URL}/media/publication-list`,
    GetMediaCoverageMenu: `${API_URL}/app/get/media`,

    CreateContactUsData: `${API_URL}/contactus/create`,

    //Evolve pricing data API
    EvolvePricingData:(data)=> `${API_URL}/subscription/product/public/list?status=${data?.status}`,
    DevelopConfigdata: `${API_URL}/subscription/config/public/data`,
    
    //Subscription query API
    SubscriptionQuerySubmitData: (productType) => `${API_URL}/subscription/query/create/${productType === "DEVELOP" ? "develop" : "evolve"}`,

    //Flash Cards API
    GetFlashCardsList:(data)=> `${API_URL}/backend/flash-cards/enable-list?title=${data?.title}&toDate=${data?.toDate}&fromDate=${data?.fromDate}&page=${data?.page}&size=${data?.size}`,
    GetFlashCardsBySlug: (slug) => `${API_URL}/backend/flash-cards/get-by-slug?slug=${slug}`,
    RecomendedFlashCardsList: (data) => `${ML_URL}/recommended/get-flash-card-details/?userId=${data?.userId}&page=${data?.page}&size=${data?.size}`,

    //Promotion API
    GetPromotionData: (data) => `${API_URL}/backend/promotion/unauth/get_for_user?userId=${data?.userId}&screenName=${data?.screenName}`,
    UpdatePromotionReaction: `${API_URL}/backend/promotion/reaction`,

    //Post API
    GetCommunityCategoryData: `${API_URL}/backend/post/community/stats`,

    //Request callback API
    CreateCallbackRequest: `${API_URL}/request/callback/create`,

    //Privacy Policy API
    SendEmailForPrivacyPolicy: (data) => `${API_URL}/privacy/policy/user/send-email?userId=${data?.userId}`
    
};

export { API_URL, Apis };
